import React, { useRef, useEffect } from 'react'
import lottie from 'lottie-web'
import getStaticPath from 'functions/getStaticPath'
import styles from '../pages.module.scss'

const Seat = () => {
  const ContainerLottieRef = useRef(null)

  useEffect(() => {
    const logoAnimation = lottie.loadAnimation({
      container: ContainerLottieRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: getStaticPath('/LoginPage/data.json'),
    })
    logoAnimation.play()
  }, [])

  return <div className={styles.seat} ref={ContainerLottieRef} />
}

export default Seat
